import './src/main.css'
import ScrollRankingBoard from './src/main.vue'

export default function (Vue) {
  Vue.component(ScrollRankingBoard.name, ScrollRankingBoard)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/scrollRankingBoard/index.js